export default __webpack_public_path__ + "static/media/GreenDot.b3b69ba0.svg";